import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
export const repost = async (data) => {
  const form = new FormData();
  const body = {
    alunoid: _cookies.getItem("auth").user?.alunoid,
    postagemid: data.postId,
  };
  form.append("dados", `[${JSON.stringify(body)}]`);
  const res = await axios.middleware.post("/Social.asmx/Repost", form);
  return res[0].data;
};

export const useCreateRepost = ({ config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: repost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["socialMediaFeed"] });
    },
  });
};
